import React, { useEffect, useState } from "react";
import "./AdminLandingScreen.css";
import Button from "../../../components/Button/Button";
import ButtonDelete from "../../../components/ButtonDelete/ButtonDelete";
import Navbar from "../../../components/Navbar/Navbar";
import { useNavigate } from "react-router-dom";

/**Firebase Imports**/
import {
	query,
	collection,
	doc,
	getDoc,
	getDocs,
	db,
	auth,
} from "../../../firebaseConfig";
/** **/

const AdminLandingScreen = () => {
	const navigate = useNavigate();
	const [extraLinks, setExtraLinks] = useState([]);
	const [updateLinks, setUpdateLinks] = useState(false);

	// eslint-disable-next-line no-unused-vars
	const [imagePreview, setImagePreview] = useState(auth.currentUser.photoURL);
	// eslint-disable-next-line no-unused-vars
	const [name, setName] = useState(auth.currentUser.displayName);
	const [userName, setUserName] = useState("");

	useEffect(() => {
		const getLinks = async () => {
			const tempArr = [];
			const querySnapshot = await getDocs(query(collection(db, "links")));
			querySnapshot.forEach((doc) => {
				tempArr.push({
					id: doc.id,
					URL: doc.data().URL,
					description: doc.data().description,
					heading: doc.data().heading.toUpperCase(),
				});
			});
			setExtraLinks(tempArr);
		};
		getLinks();
	}, [navigate, updateLinks]);
	/** **/

	/**
	 * Main Functions
	 * **/
	useEffect(() => {
		const docRef = doc(db, "users", auth.currentUser.uid);
		const getUserName = async () => {
			const docSnap = await getDoc(docRef);
			if (docSnap.exists()) {
				setUserName(docSnap.data().userName);
			}
		};

		getUserName();
		return () => {
			console.log("");
		};
	}, []);
	/** **/

	return (
		<div className="AdminLandingScreen h-full w-full overflow-y-auto m-0 p-0">
			<div className="h-full w-full  m-0 p-3 py-8">
				<Navbar backTarget={"/admin"} />

				<div className="topSection flex flex-col items-center">
					<div className="avatar relative mt-10 w-full">
						<div className="circle1 rounded-full h-28 w-28 flex items-center justify-center overflow-hidden mx-auto">
							<img
								src={
									imagePreview
										? "https://firebasestorage.googleapis.com/v0/b/john-trucking.appspot.com/o/profile-images%2F" +
										  auth.currentUser.uid +
										  imagePreview
										: require("../../../images/avatar.png")
								}
								alt="avatar_img"
								className="h-full object-cover rounded-full"
							/>
						</div>
					</div>

					<input
						type="text"
						name="name"
						id="name"
						className={`name mt-6 w-full text-center text-2xl font-bold rounded`}
						value={name}
						readOnly={true}
					/>

					<input
						type="text"
						name="userName"
						id="userName"
						className={`name mt-1 w-full text-center text-lg rounded`}
						value={`@${userName}`}
						readOnly={true}
					/>
				</div>

				<div className="w-full  flex flex-col items-center">
					<Button
						mode={"filled"}
						title={"ADD+"}
						size={"xs"}
						className={"mt-2 mb-6 mr-auto"}
						onClick={() => {
							navigate("/admin/addLink");
						}}
					/>
				</div>

				<div className="w-full  flex flex-col items-center">
					<Button
						className={"my-2 font-bold"}
						title={"FIXED COST"}
						mode={"filled"}
						size={"full"}
					/>
					<Button
						className={"my-2 font-bold"}
						title={"VARIABLE COST"}
						mode={"filled"}
						size={"full"}
					/>
					<Button
						className={"my-2 font-bold"}
						title={"WEEKLY COST CALCULATION"}
						mode={"filled"}
						size={"full"}
					/>

					{extraLinks.map(({ heading, id, URL, description }, index) => (
						<ButtonDelete
							id={id}
							key={index}
							className={"my-2 font-bold"}
							title={heading}
							description={description}
							mode={"filled"}
							size={"full"}
							updateLinks={updateLinks}
							setUpdateLinks={setUpdateLinks}
							URL={URL}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

export default AdminLandingScreen;
